// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
const templateHelpers = require('./template-helpers');
const { adams } = require('app/scripts/lib/adams');

module.exports = templateHelpers(adams);
